import React from "react";
import {
  FaLightbulb,
  FaDraftingCompass,
  FaCode,
  FaRocket,
} from "react-icons/fa";
import "./Process.css";

const Process = () => {
  return (
    <section className="uniq-oglitz-process">
      <div className="uniq-oglitz-process__container">
        {/* HEADER */}
        <div className="uniq-oglitz-process__header">
          <span className="uniq-oglitz-process__badge">Our Process</span>

          <h2 className="uniq-oglitz-process__title">
            How We <span>Transform Ideas</span>
            <br />
            Into Scalable Digital Products
          </h2>

          <p className="uniq-oglitz-process__subtitle">
            A proven, transparent development process designed to deliver
            high-quality, scalable, and future-ready software solutions.
          </p>
        </div>

        {/* PROCESS STEPS */}
        <div className="uniq-oglitz-process__timeline">
          <div className="uniq-oglitz-process__step">
            <div className="uniq-oglitz-process__icon">
              <FaLightbulb />
            </div>
            <h4>Discovery & Strategy</h4>
            <p>
              We understand your business goals, users, and technical
              requirements to define a clear product roadmap.
            </p>
          </div>

          <div className="uniq-oglitz-process__step">
            <div className="uniq-oglitz-process__icon">
              <FaDraftingCompass />
            </div>
            <h4>UI/UX & Architecture</h4>
            <p>
              We design intuitive user experiences and clean system architecture
              focused on performance and scalability.
            </p>
          </div>

          <div className="uniq-oglitz-process__step">
            <div className="uniq-oglitz-process__icon">
              <FaCode />
            </div>
            <h4>Development & Testing</h4>
            <p>
              Agile development with continuous testing ensures quality,
              security, and smooth integrations.
            </p>
          </div>

          <div className="uniq-oglitz-process__step">
            <div className="uniq-oglitz-process__icon">
              <FaRocket />
            </div>
            <h4>Launch & Scale</h4>
            <p>
              We deploy, monitor, and scale your product while providing
              long-term technical support and optimization.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
